<div class="search-container w-96">
  @if (!isSelectVisible) {
    <div class="search-input">
      <p-iconfield>
        <p-inputicon [styleClass]="iconClass" />
        <input
          autocomplete="off"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="off"
          data-gramm="false"
          type="text"
          pInputText
          [placeholder]="placeholder"
          [attr.aria-label]="placeholder"
          class="w-full"
          [(ngModel)]="searchQuery"
          (focus)="showSelect()"
          (input)="onSearchInput($event)" />
      </p-iconfield>
    </div>
  }

  @if (isSelectVisible) {
    <div class="search-select">
      <p-select
        #selectComponent
        [options]="options"
        [(ngModel)]="selectedOption"
        [loading]="loading"
        [group]="group"
        [editable]="true"
        [showClear]="true"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [optionGroupLabel]="optionGroupLabel"
        [optionGroupChildren]="optionGroupChildren"
        [ariaLabel]="placeholder"
        (onChange)="onOptionChange($event)"
        (onShow)="onSelectShow()"
        (onHide)="onSelectHide()"
        (onClear)="onSelectClear()"
        (onBlur)="onSelectBlur()"
        (onFocus)="onSelectFocus()"
        [(ngModel)]="searchQuery"
        class="w-full"
        [pAutoFocus]="isSelectVisible">
        <ng-template #dropdownicon>
          <ces-icon size="input" containerSize="input">keyboard_arrow_down</ces-icon>
        </ng-template>
        <ng-template #group let-group>
          <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: group }" />
        </ng-template>
        @if (itemTemplate) {
          <ng-template #item let-item>
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
          </ng-template>
        }
      </p-select>
    </div>
  }
</div>
